import React, { useState } from 'react';
import { Box } from '@mui/material';
import DynamicTabsComponent from '../../components/DynamicTabs/DynamicTabsComponent';
import MyWfhComponent from './MyWfhComponent';
import AdditionalWfhQuotaComponent from './AdditionalWfhQuotaComponent';

/**
 * /WFH — My WFH (existing) + Additional WFH quota requests.
 * WFH Tasks remain on the existing My WFH cards/dialogs.
 */
const WorkFromHome = () => {
  const [activeTab, setActiveTab] = useState(0);

  const TabsList = [
    {
      title: 'My WFH',
      component: <MyWfhComponent />,
    },
    {
      title: 'Additional WFH',
      component: <AdditionalWfhQuotaComponent />,
    },
  ];

  return (
    <Box className="main-content-overlay">
      <div className="main-content-div">
        <DynamicTabsComponent
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          TabsList={TabsList}
          isEmp
        />
      </div>
    </Box>
  );
};

export default WorkFromHome;
